import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import PageHero from '../components/PageHero'

export default function Donate() {
  return (
    <>
      <Navbar />
      <PageHero
        title="Support SISDI"
        subtitle="Your donation helps provide children with access to football, education, and life-changing opportunities."
        variant="donate"
        fadeClass="fade-in"
      />

      <main>
        <section className="section fade-in">
          <div className="container">
            <div className="section-header">
              <span className="eyebrow">Give Today</span>
              <h2>Choose How to <span className="text-accent">Donate</span></h2>
              <div className="section-divider"></div>
              <p style={{ maxWidth: '560px', margin: '1.5rem auto 0' }}>
                Every contribution, no matter the size, directly funds football
                training, educational materials, and life skills programs for children.
              </p>
            </div>

            <div className="grid-2 fade-in-stagger" style={{ maxWidth: '860px', margin: '3rem auto 0' }}>
              {/* Bank Transfer */}
              <div className="donation-card">
                <div className="icon-badge" style={{ marginBottom: '1.5rem' }}>
                  <i className="bi bi-bank" style={{ fontSize: '1.4rem', color: 'var(--color-primary)' }}></i>
                </div>
                <div className="donation-card-body">
                  <h4>Bank Transfer</h4>
                  <p style={{ marginBottom: '1.5rem' }}>Make a direct bank transfer using the details below.</p>
                  <div className="bank-details">
                    <p><strong>Account Name:</strong> Schools In Soccer Development Initiative</p>
                    <p><strong>Bank Name:</strong> United Bank for Africa (UBA)</p>
                    <p><strong>Account Number:</strong> 1029347244</p>
                    <p><strong>Currency:</strong> NGN</p>
                  </div>
                </div>
              </div>

              {/* Online Donate */}
              <div className="donation-card dark featured">
                <div className="icon-badge accent" style={{ marginBottom: '1.5rem' }}>
                  <i className="bi bi-globe" style={{ fontSize: '1.4rem' }}></i>
                </div>
                <div className="donation-card-body">
                  <h4>Donate Online</h4>
                  <p style={{ marginBottom: '1rem' }}>Secure, fast, and trusted online payments via Flutterwave.</p>
                  <p>Online donations allow us to respond quickly and scale our impact across schools and communities.</p>
                  <a
                    href="#"
                    className="disabled-link btn btn-accent"
                    aria-disabled="true"
                    style={{ marginTop: 'auto', paddingTop: '1.5rem' }}
                  >
                    Coming Soon
                  </a>
                </div>
              </div>
            </div>

            {/* Why Donate */}
            <div style={{ maxWidth: '760px', margin: '5rem auto 0', textAlign: 'center' }}>
              <span className="eyebrow">Why It Matters</span>
              <h3 style={{ marginTop: '0.5rem', marginBottom: '1.5rem' }}>
                Where Your <span className="text-accent">Money Goes</span>
              </h3>
              <div className="grid-3">
                {[
                  { icon: 'bi-trophy', label: 'Training Equipment', desc: 'Footballs, boots, and training kits for children in partner schools.' },
                  { icon: 'bi-book', label: 'Education Programs', desc: 'Books, materials, and literacy initiatives like Read, Learn, Play.' },
                  { icon: 'bi-people', label: 'Coaching & Mentorship', desc: 'Qualified coaches and mentors who guide children on and off the pitch.' },
                ].map((item, i) => (
                  <div key={i} style={{ textAlign: 'center', padding: '1.5rem 1rem' }}>
                    <div className="icon-badge" style={{ margin: '0 auto 1rem' }}>
                      <i className={`bi ${item.icon}`} style={{ fontSize: '1.4rem', color: 'var(--color-primary)' }}></i>
                    </div>
                    <h5 style={{ marginBottom: '0.5rem' }}>{item.label}</h5>
                    <p style={{ fontSize: '0.9rem' }}>{item.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  )
}
